import React from 'react';
import BrandDetailsCard from 'components/brand-details-card';
import CokitchenImageDetailCard from 'components/cokitchen-image-detail-card';
import Chip from 'components/base/chip';
import LiveTag from 'components/live-tag';
import useDashboardContext from 'contexts/dashboard.context';

const PreviewKitchenDetails = () => {
  const { activeCokitchen } = useDashboardContext();
  return (
    <div>
      <BrandDetailsCard
        data={{ label: 'Cokitchen name', value: activeCokitchen?.name }}
        className='my-4'
      />
      <BrandDetailsCard
        data={{ label: 'Cokitchen address', value: activeCokitchen?.address }}
        className='my-4'
      />
      <BrandDetailsCard
        data={{ label: 'Cokitchen Tagline', value: activeCokitchen?.description }}
        className='my-4'
      />
      <BrandDetailsCard
        data={{ label: 'Cokitchen type', value: activeCokitchen?.cokitchen_type }}
        className='my-4'
      />

      <BrandDetailsCard
        data={{
          label: 'Customer service Number',
          value: null,
          tag: (
            <div className='flex flex-wrap gap-4 font-medium'>
              {activeCokitchen?.customer_service_phone_number?.map((item, index) => (
                <Chip key={index} text={item} />
              ))}
            </div>
          )
        }}
        className='my-4'
      />
      <BrandDetailsCard
        data={{
          label: 'Customer service Number (WhatsApp)',
          value: null,
          tag: (
            <div className='flex flex-wrap gap-4 font-medium'>
              {activeCokitchen?.customer_service_whatsapp?.map((item, index) => (
                <Chip key={index} text={item} />
              ))}
            </div>
          )
        }}
        className='my-4'
      />
      <BrandDetailsCard
        data={{
          label: 'Front desk Number',
          value: null,
          tag: (
            <div className='flex flex-wrap gap-4 font-medium'>
              {activeCokitchen?.frontdesk_phone_number?.map((item, index) => (
                <Chip key={index} text={item} />
              ))}
            </div>
          )
        }}
        className='my-4'
      />
      <BrandDetailsCard
        data={{
          label: 'Front desk Number (WhatsApp)',
          value: null,
          tag: (
            <div className='flex flex-wrap gap-4 font-medium'>
              {activeCokitchen?.frontdesk_whatsapp?.map((item, index) => (
                <Chip key={index} text={item} />
              ))}
            </div>
          )
        }}
        className='my-4'
      />
      <div className='border py-[20px] px-[24px] border-[#EDEDEE] rounded-xl flex justify-between my-8'>
        <div className='flex items-center justify-start gap-12'>
          <p className='text-[#858585] font-medium'>Cokitchen Status</p>
          <LiveTag live={activeCokitchen.active} />
        </div>
      </div>
      <CokitchenImageDetailCard
        image={activeCokitchen.event_image ?? ''}
        cover_images={activeCokitchen.cover_images ?? []}
        cover_videos={activeCokitchen.cover_videos ?? []}
      />
    </div>
  );
};

export default PreviewKitchenDetails;
